import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUserHasMemberOfType } from '../reducers/userReducer';
import { CLEARING_BROKER_DEALER_MEMBER_TYPE } from '../constants/memberTypes';
import EnvPromise from '../config/env';
import useIsFCM from './useIsFCM';

/* Use this hook to know if the currentUser is CBD Type Member*/
const useIsCBD = () => {
  const dispatch = useDispatch();
  const [enableKpi, setEnableKpi] = useState<string | null>(null);
  const isCurrentUserCBDTypeMember = useSelector((state) =>
    getUserHasMemberOfType(state, [CLEARING_BROKER_DEALER_MEMBER_TYPE]),
  );

  useEffect(() => {
    EnvPromise.then((env) => setEnableKpi(env.enableKpi));
  }, [dispatch]);

  if (enableKpi === null) return null;
  if (enableKpi !== undefined) {
    return isCurrentUserCBDTypeMember && enableKpi === 'true';
  }
  return false;
};
export default useIsCBD;

export const useIsNotCBD = () => {
  const isCbd = useIsCBD();
  return !isCbd;
};

export const useIsFCMOrCBD = () => {
  const isFcm = useIsFCM();
  const isCbd = useIsCBD();
  // Wait for both to resolve
  if (isFcm === null || isCbd === null) return null;
  return isFcm || isCbd;
};

export const useIsNotFCMAndNotCBD = () => {
  const isFcm = useIsFCM();
  const isCbd = useIsCBD();
  // Wait for both to resolve
  if (isFcm === null || isCbd === null) return null;
  return !isFcm && !isCbd;
};
